import { call, put, takeLatest } from 'redux-saga/effects';
import { AxiosResponse } from 'axios';

import { COMMON_TYPES } from './commonTypes';
import * as Actions from './commonActions';
import { CategoryApi } from '../../features/category/api/categoryApi';
import { CommonApi } from '../api/commonApi';
import { CategoryListGetResponse } from '../../features/category/model/categoryModel';
import { TagGetResponse } from '../model/commonModel';
import { KeywordApi } from '../../features/keyword/api/keywordApi';
import { KeywordGetResponse } from '../../features/keyword/model/keywordModel';

function* getCategoriesListSaga() {
  try {
    const response: AxiosResponse<CategoryListGetResponse[]> = yield call(CategoryApi.getList, {});
    yield put(Actions.getCategoriesListSuccess(response.data));
  } catch (error) {
    // @ts-ignore
    console.log('SAGA ERROR', error.response);
  }
}

function* getTagsListSaga() {
  try {
    const response: AxiosResponse<TagGetResponse[]> = yield call(CommonApi.getTags, {});
    yield put(Actions.getTagsListSuccess(response.data));
  } catch (error) {
    // @ts-ignore
    console.log('SAGA ERROR', error.response);
  }
}

function* getKeywordsListSaga() {
  try {
    const response: AxiosResponse<KeywordGetResponse[]> = yield call(KeywordApi.getAll, {});
    yield put(Actions.getKeywordsListSuccess(response.data));
  } catch (error) {
    // @ts-ignore
    console.log('SAGA ERROR', error.response);
  }
}

export default function* watch() {
  yield* [
    takeLatest(COMMON_TYPES.GET_CATEGORIES_LIST, getCategoriesListSaga),
    takeLatest(COMMON_TYPES.GET_TAGS_LIST, getTagsListSaga),
    takeLatest(COMMON_TYPES.GET_KEYWORDS_LIST, getKeywordsListSaga),
  ];
}
